import { render } from "./NewWay.vue?vue&type=template&id=fe455ec4"
import script from "./NewWay.vue?vue&type=script&lang=js"
export * from "./NewWay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__